const typeCode = {

    DISH_TYPE: {
        //料理
        DISH: 1,
        //間食
        SNACK: 2,
    },

    COOKING_METHOD_TYPE: {
        //未定義
        UNDEFINED: 0,
        //焼
        GRILLED: 1,
        //煮
        TUNNEL: 2,
        //揚
        FRIED: 3,
        //蒸
        STEAM: 4,
        //茹
        BOIL: 5,
        //炒
        FRY: 6,
    },

    SEASON_TYPE: {
        //未定義
        UNDEFINED: 0,
        //春
        SPRING: 1,
        //夏
        SUMMER: 2,
        //秋
        FALL: 3,
        //冬
        WINTER: 4,
        //春・夏
        SPRING_SUMMER:5,
        //春・秋
        SPRING_FALL:6,
        //春・冬
        SPRING_WINTER:7,
        //夏・秋
        SUMMER_FALL:8,
        //夏・冬
        SUMMER_WINTER:9,
        //秋・冬
        FALL_WINTER:10
    },

    FACE_ICON_TYPE: {
        //男3
        MALE_3: '1_3',
        //男4
        MALE_4: '1_4',
        //男5
        MALE_5: '1_5',
        //男6
        MALE_6: '1_6',
        //男7
        MALE_7: '1_7',
        //男8
        MALE_8: '1_8',
        //男9
        MALE_9: '1_9',

        //女3
        FEMALE_3: '2_3',
        //女4
        FEMALE_4: '2_4',
        //女5
        FEMALE_5: '2_5',
        //女6
        FEMALE_6: '2_6',
        //女7
        FEMALE_7: '2_7',
        //女8
        FEMALE_8: '2_8',
        //女9
        FEMALE_9: '2_9',
    },

    SEX_TYPE: {
        //男
        MALE: 1,
        //女
        FEMALE: 2,
    },

    MAPPING_SEX_TYPE: {
        //男
        1: "男性",
        //女
        2: "女性"
    },

    ACTIVITY_AMOUNT_TYPE: {
        //レベル1
        LEVEL1: 1,
        //レベル2
        LEVEL2: 2,
        //レベル3
        LEVEL3: 3,
    },

    MAPPING_ACTIVITY_AMOUNT_TYPE: {
        //レベル1
        1: "(低い)",
        //レベル2
        2: "(ふつう)",
        //レベル3
        3: "(高い)",
    },

    MENU_TYPE: {
        //献立
        MENU: 1,
        //セットメニュー
        SET_MENU: 2,
        //課題
        TASK: 3,
    },

    MENU_SUBJECT_SELECT_MENU: 4,

    MEAL_TYPE: {
        //朝食
        BREAKFAST: 1,
        //昼食
        LUNCH: 2,
        //夕食
        DINNER: 3,
        //間食
        SNACK: 4,
        //1食
        A_MEAL: 5,
    },

    MAPPING_MEAL_TYPE: {
        //朝食
        1: "朝 食",
        //昼食
        2: "昼 食",
        //夕食
        3: "夕 食",
        //間食
        4: "間 食",
    },

    NUTRIENTS_TYPE: {
        //炭水化物
        STARCH: 1,
        //脂質
        FAT: 2,
        //たんぱく質
        PROTEIN: 3,
        //無機質
        MINERAL: 4,
        //ビタミン
        VITAMIN: 5,
    },

    MEAL_NUM_TYPE: {
        //1食分
        A_MEAL: 1,
        //1日分（間食あり）
        A_DAY_SNACK: 2,
        //1日分（間食なし）
        A_DAY_NO_SNACK: 3,
    },

    FOOD_GROUP_TYPE: {
        GROUP_FOUR: {
            GROUP_1: {
                //4群の1群（乳製品）
                MILK: '4_1_1',
                //4群の1群（卵）
                EGG: '4_1_2',
            },
    
            GROUP_2: {
                //4群の2群（魚介等
                FISH: '4-2_1',
                //4群の2群（豆製品）
                BEAN: '4_2_2',
            },
    
            GROUP_3: {
                //4群の3群（野菜）
                VEGETABLE: '4_3_1',
                //4群の3群（いも）
                POTATOES: '4_3_2',
                //4群の3群（果実）
                SEED: '4_3_3',
            },
    
            GROUP_4: {
                //4群の4群（穀類）
                CEREALS: '4_4_1',
                //4群の4群（砂糖）
                SUGAR: '4_4_2',
                //4群の4群（油脂）
                OIL: '4_4_3',
            }
        },

        GROUP_SIX: {
            //6群の1群
            GROUP_1: '6_1',
            //6群の2群
            GROUP_2: '6_2',
            //6群の3群
            GROUP_3: '6_3',
            //6群の4群
            GROUP_4: '6_4',
            //6群の5群
            GROUP_5: '6_5',
            //6群の6群
            GROUP_6: '6_6',
        },

    },

    DISH_SIZE_TYPE: {
        //小
        SMALL: 1,
        //中
        MEDIUM: 2,
        //大
        BIG: 3,
    },

    SAVE_DATA_TYPE: {
        //保存データ
        SAVED: 1,
        //提出データ
        SENT: 2,
    },

    CUTLERY_TYPE: {
        //プレースマット
        DISK_CARD: 1,
        //箸カトラリー
        CHOPSTICKS: 2,
    },

    REL_DISH_TYPE: {
        DISH: 1,
        USER_DISH: 2,
        USER_SUBJECT_DISH: 3,
        USER_SUBMIT_DISH: 4,
    },

    FOOD_SEARCH: {
        DISH: 1,
        USER_DISH: 2
    },

    IS_ORIGINAL: '★ '
};
export default typeCode;